import Utils from "@/common/util.js";
import home from './home'
import trade from './trade'
import property from './property'
import quotes from './quotes'
// import packet from './packet'
  
  export default [
    
    ...home,
    ...trade,
    ...property,
    ...quotes,
    //   {
    //   path: "/h5/packet",
    //   name: "h5-packet",
    //   component: () => import('@/pages/v2/h5/packet/index'),
    // },
    {
      path: "/h5/login",
      name: "h5-login",
      component: () => import('@/pages/v2/h5/login'),
    },
    {
      path: "/h5/register",
      name: "h5-register",
      component: () => import('@/pages/v2/h5/register'),
    },
    {
      path: '/h5/password/forget',
      name: "h5-password-forget",
      component: () => import('@/pages/v2/h5/forget'),
    },
    {
      path: '/h5/promotion',
      name: "h5-promotion",
      component: () => import('@/pages/v2/h5/promotion')
    },
    {
      path: '/h5/trading',
      name: "h5-trading",
      component: () => {
        const {startTime, endTime} = JSON.parse(sessionStorage.getItem('activity_time'))
        let flag = Utils.countDownTime(startTime, endTime)
        if (flag.noStart){
          return import('@/pages/v2/h5/newTradingContest/index')
        } else if(flag.active) {
          return import('@/pages/v2/h5/newTradingContest/activityStart')
        } else if (flag.end){
          return import('@/pages/v2/h5/newTradingContest/activeEndList')
        } else {
          return import('@/pages/v2/h5/newTradingContest/index')
        }
      }
    },
    // {
    //   path: '/h5/trading/activeEnd',
    //   name: "h5-trading-end",
    //   component: () => import('@/pages/v2/h5/newTradingContest/activeEndList')
    // },
    {
      path: '/h5/trading/rules',
      name: "h5-trading-rules",
      component: () => import('@/pages/v2/h5/newTradingContest/activityRules')
    },
    {
      path: '/h5/trading/myStar',
      name: "h5-trading-myStar",
      component: () => import('@/pages/v2/h5/newTradingContest/myStar')
    },
    {
      path: '/h5/trading/awardsList',
      name: "h5-trading-awardsList",
      component: () => import('@/pages/v2/h5/newTradingContest/awardsList')
    },
    {
      path: '/h5/invitation',
      name: "h5-invitation",
      component: () => import('@/pages/v2/h5/trading/invitation')
    },
    {
      path: '/h5/games',
      name: "h5-games",
      component: () => import('@/pages/v2/h5/games')
    },
    {
      path: '/h5/sports',
      name: "h5-sports",
      component: () => import('@/pages/v2/h5/sports')
    },
    {
      path: '/h5/earn',
      name: "h5-earn",
      component: () => import('@/pages/v2/h5/earn')
    },
    {
      path: '/h5/startup',
      name: "h5-ieo",
      component: () => import('@/pages/v2/h5/ieo')
    },
    {
      path: '/h5/subscription',
      name: "h5-subscription",
      component: () => import('@/pages/v2/h5/ieo/subscription')
    },
    {
      path: '/h5/startup/details',
      name: "h5-details",
      component: () => import('@/pages/v2/h5/ieo/details')
    },
    {
      path: '/h5/arouse/app',
      name: "h5-arouse-app",
      component: () => import('@/pages/v2/h5/arouse-app')
    },
    {
      path: '/h5/user',
      name: "h5-user",
      component: () => import('@/pages/v2/h5/userCenter')
    },
    {
      path: '/h5/user/authentication',
      name: "h5-user-authentication",
      component: () => import('@/pages/v2/h5/userCenter/authentication')
    },
    {
      path: "/h5/packet",
      name: "h5-packet",
      component: () => import('@/pages/v2/h5/packet/index'),
    },
    // todo::: 旧版本交易大赛h5地址
    {
      path: '/h5/old/trading',
      name: "h5-trading-end",
      component: () => import('@/pages/v2/h5/trading/index')
    },
  ]


// WEBPACK FOOTER //
// ./src/router/v2/h5/index.js